<template>
    <div>
        <MulReportHeader :dataFrom="table.params" @search="searchData" :loading="loading" :toPdf="toPdf" :excelShow="true" :toExe="handicapExe"></MulReportHeader>
        <Collapse v-model="panelName">
            <Panel :key="index" :name="`${item.platid}`" v-for="(item, index) in table.data">
                {{ item.platname }}
                <Table border :columns="table.columns" :data="item.data" style="margin-top: 12px" ref="tableRef" slot="content"></Table>
            </Panel>
        </Collapse>
        <!-- <Page
            v-show="table.data.length"
            show-sizer
            show-total
            style="margin-top:10px;"
            :total="table.total"
            :current="table.params.page"
            :page-size-opts="table.pageSizes"
            :page-size="table.params.limit"
            @on-page-size-change="limitchange"
            @on-change="pagechange"
        ></Page>-->
    </div>
</template>

<script>
import MulReportHeader from './components/mul_report_header.vue'
import { TransTopReq } from '@/api/admin/risk'
import moment from 'moment'
export default {
    name: 'HandicapRevenueData',
    components: { MulReportHeader },
    data() {
        return {
            panelName: [],
            plat_app: {},
            TransTopReqTimer: null,
            current_limit: { app_list: [], stime: 0, etime: 0 },
            loading: false,
            table: {
                params: {
                    platids: [],
                    app_id: 0,
                    app_ids: [],
                    dataTime: this.getCurrentZeroDay()
                },
                data: [],
                columns: [
                    { type: 'index', title: '序号', align: 'center', width: 60 },
                    { key: 'app_name', width: 90, align: 'center', renderHeader: (h) => this.renderHeader(h, '盘口', '显示对应的盘口名称') },
                    this.rRPointC('pay_ave', 'ARPPU', '统计盘口筛选时间内的【转入金额】/【转入人数', 110),
                    this.rRPointC('pay_ave_offset', 'ARPPU环比', '当日ARPPU-昨日Arppu', 110, {
                        render: (h, params) => {
                            let value = params.row.pay_ave_offset
                            let color = this.getCompColor(value)
                            return h('span', { style: { color } }, this.getCustomFixed(value / 10000))
                        }
                    }),
                    this.rRPointC('pay_sum', '转入金额', '统计盘口筛选时间内的转入金额', 110),
                    this.rRPointC('pay_sum_offset', '转入金额环比', '当日转入金额-昨日转入金额', 110, {
                        render: (h, params) => {
                            let value = params.row.pay_sum_offset
                            let color = this.getCompColor(value)
                            return h('span', { style: { color } }, this.getCustomFixed(value / 10000))
                        }
                    }),
                    this.rRRateC('bet_pay_rate', '投注转入比', '统计盘口筛选时间内(【投注金额】/【转入金额】)', 110, {
                        render: (h, params) => h('span', this.getCustomFixed(params.row.bet_pay_rate))
                    }),
                    this.rRRateC('pay_put_rate', '投注转入比环比', '当日投注转入比 - 昨日投注转入比', 110, {
                        render: (h, params) => {
                            let value = params.row.bet_pay_rate_offset
                            let color = this.getCompColor(value)
                            return h('span', { style: { color } }, this.getCustomFixed(value))
                        }
                    }),
                    this.rRRateC('pay_put_rate', '转入转出比', '(【转入金额】-【转出金额】) /【转入金额】', 110),
                    this.rRRateC('new_win_rate', '营收比', '统计盘口(【今日转入】-【今日转出】+【昨日余额】-【今日余额】) /【转入金额', 110),
                    this.rRPointC('game_loss_sum', '游戏盈亏', '统计盘口筛选时间内【投注金额】-【返奖金额】', 110),
                    this.rRPointC('percent_sum', '税收金额', '统计盘口筛选时间内的税收金额', 110),
                    this.rRRateC('game_win_lose_rate', '游戏盈利率', '统计盘口筛选时间内游戏盈亏/投注金额', 110),
                    this.rRPointC('send_total_percent_sum', '佣金', '统计盘口筛选时间内发放的佣金金额', 110),
                    this.rRPointC('give_sum', '赠送金额', '', 110),
                    this.rRRateC('pay_winner_rate', '转入赢家人数占比', '', 110),
                    this.rRateC('give_pay_rate', '赠送佣金转入比', '（赠送金额 + 佣金）/ 转入金额', 80)
                ]
            }
        }
    },
    methods: {
        //查询数据
        searchData(emitProps) {
            if (this.loading) return
            this.plat_app = { ...emitProps }
            let paramsList = this.getAllHttpAppid(this.table.params)
            this.table.data = []
            let all = {}
            let httpList = []
            let loadingArr = [...paramsList]
            this.panelName = []
            let stime = this.getSecond(this.table.params.dataTime)
            let etime = this.getSecond(this.table.params.dataTime, false)
            for (let i = 0, len = paramsList.length; i < len; i++) {
                let app_id = paramsList[i]
                let app_name = ''
                let platid = 0
                let platname = ''
                let item = emitProps.app_list.find((el) => el.appid == app_id)
                if (item) {
                    app_name = item.appName
                    platid = item.platform
                    platname = emitProps.plat_list.find((el) => el.id == platid).name
                }
                if (!all[platid]) {
                    all[`${platid}`] = this.getAllItem(platid)
                }
                let param = this.getTransTopParams('GetNewPlatfromData', { platid, platname, app_name, app_id, stime, etime, general: -1, pack_no: -1, page: 1, limit: 10000, sort: 0 })
                httpList.push(param)
            }
            this.openTimer()
            this.current_limit = {
                app_list: [...paramsList],
                stime,
                etime
            }
            for (let s = 0; s < 5; s++) {
                this.toHttp(httpList, all, loadingArr)
            }
        },
        toPdf() {
            this.panelName = this.table.data.map((el) => `${el.platid}`)
            this.$nextTick(() => {
                this.eleToPdf()
            })
        },
        handicapExe() {
            let { stime, etime, app_list } = this.current_limit
            let reqList = []
            let loadingArr = []
            for (let i = 0; i < app_list.length; i++) {
                let app_id = app_list[i]
                let app_name,
                    platname = ''
                let platid = 0
                let item = this.plat_app.app_list.find((el) => el.appid == app_id)
                if (item) {
                    app_name = item.appName
                    platid = item.platform
                    platname = this.plat_app.plat_list.find((el) => el.id == platid).name
                }
                let params = this.getTransTopParams('GetNewPlatfromData3', { platid, platname, app_name, app_id, stime, etime, general: -1, pack_no: -1 })
                reqList.push(params)
                loadingArr.push(1)
            }
            let max = Math.min(5, reqList.length)
            let all = []
            for (let i = 0; i < max; i++) {
                this.toGetExcelData(reqList, all, loadingArr)
            }
        },
        async toGetExcelData(httpList, alls, loadingArr) {
            if (httpList.length > 0) {
                let param = httpList.shift()
                TransTopReq(param)
                    .then((res) => {
                        if (res._param.list) {
                            alls.push(...res._param.list)
                        }
                        loadingArr.shift()
                        if (loadingArr.length == 0) {
                            this.realDownLoad(alls)
                        }
                        if (httpList.length > 0) this.toGetExcelData(httpList, alls, loadingArr)
                    })
                    .catch((err) => {
                        loadingArr.shift()
                        if (loadingArr.length == 0) {
                            this.realDownLoad(alls)
                        }
                        if (httpList.length > 0) this.toGetExcelData(httpList, alls, loadingArr)
                    })
            }
        },
        realDownLoad(data) {
            if (data.length > 0) {
                let str = '盘口,日期,转入总金额,营收金额,投注金额,税收金额,大R转入金额,活跃人数,投注人数,充投人数,转入人数,大R人数,历史代理人数,佣金发放人数,佣金发放金额,代理拉新人数,代理拉新首充人数,的新增绑定上级且转入总额,人数转入转出比,赢家数占比,转入赢家数占比,实钱赢家数占比,线上活动彩金,系统赠送金额,转入用户次留存,转入用户3日留存,新增转入用户次日复充,新增转入用户3日复充,转入用户次日复充,转入用户3日复充,转入用户7日复充,新增人数,新增转入人数,新增转入总金额,线上转入人数,银行卡转入人数,VIP转入人数,线上转入成功笔数,线上转入提交笔数,线上成功转入金额,PVP投注金额,PVP充投人数,PVP税收金额,PVE投注金额,PVE充投人数,PVE游戏盈亏,游戏盈亏,新增转入用户7日复充,转入用户7日留存,转出人数,自营佣金,新增转入用户次日复充金额,新增转入用户3日复充金额,新增转入用户7日复充金额,新增转入用户次日复充人数,新增转入用户3日复充人数,新增转入用户7日复充人数,提款金额,赠送总金额,首充人数,转入次日复充金额,转入三日复充金额,转入七日复充金额\n'
                let date = moment(data[0].idate).locale('zh-cn').format('YYYY/MM/DD')
                data.sort((a, b) => (a.app_id > b.app_id ? 1 : -1))
                data.forEach((item) => {
                    let app_name = item.app_name ? `${item.app_name}`.replace('棋牌', '').replace('娱乐', '') : ''
                    str += `${app_name},${date},${item.pay_sum},${item.new_win_sum},${item.bet},${item.percent},${item.r_money},${item.active_num},${item.bet_user_num},${item.pay_bet_user_num},${item.pay_user_num},${item.r_user_num},${item.h_team_num},${item.user_agent_commi_num},${item.user_agent_commi_sum},${item.agent_pull_user_num},${item.agent_pull_user_first_num},${item.bind_top_new_user_pay_sum},${item.put_pay_rate},${item.winner_rate},${item.pay_winner_rate},${item.money_win_rate},${item.online_activity_point},${item.sys_give_sum},${item.pay_user_next_day_stay_rate},${item.pay_user_three_day_stay_rate},${item.new_user_next_day_pay_rate},${item.new_user_next_three_day_pay_rate},${item.pay_user_next_day_pay_rate},${item.pay_user_three_day_pay_rate},${item.pay_user_seven_day_pay_rate},${item.new_user_num},${item.new_user_pay_num},${item.new_user_pay_total_sum},${item.down_pay_num},${item.bank_pay_num},${item.vip_pay_num},${item.online_pay_success_num},${item.online_pay_commit_num},${item.online_pay_success_sum},${item.pvp_bet_sum},${item.pvp_pay_bet_num},${item.pvp_percent_sum},${item.pve_bet_sum},${item.pve_pay_bet_num},${item.pve_loss_sum},${item.lost},${item.new_user_next_seven_day_pay_rate},${item.pay_user_seven_day_stay_rate},${item.put_num},${item.self_commi},${item.new_user_next_pay_money},${item.new_user_three_pay_money},${item.new_user_seven_pay_money},${item.new_user_next_pay_user},${item.new_user_three_pay_user},${item.new_user_seven_pay_user},${item.put_sum},${item.give_sum},${item.fist_pay_num},${item.ci_ri_pay_sum || 0},${item.three_pay_sum || 0},${item.seven_pay_sum || 0}\n`
                })
                this.noTableCsvToXlsx(str, `盘口营收 ${date}`)
            } else {
                this.$Message.error('无数据')
            }
        },
        getAllItem(platid) {
            return {
                platid,
                app_id: -10,
                plat_form_name: '',
                app_name: '合计',
                pay_ave: 0,
                pay_ave_offset: 0,
                pay_sum: 0,
                pay_num: 0,
                y_pay_sum: 0,
                y_pay_num: 0,
                pay_num_offset: 0,
                pay_sum_offset: 0,
                bet_pay_rate: 0,
                bet_pay_rate_offset: 0,
                pay_put_rate: 0,
                new_win_rate: 0,
                new_win_sum: 0,
                y_new_win_sum: 0,
                game_loss_sum: 0,
                percent_sum: 0,
                send_total_percent_sum: 0,
                give_sum: 0,
                give_pay_rate: 0,
                game_win_lose_rate: 0,
                pay_winner_rate: 0,
                pay_winner: 0,
                pay_loser: 0,
                y_pay_winner: 0,
                y_pay_loser: 0,
                bet_sum: 0,
                put_sum: 0,
                y_bet_sum: 0,
                y_put_sum: 0
            }
        },
        async toHttp(httpList, alls, loadingArr) {
            if (httpList.length > 0) {
                let param = httpList.shift()
                TransTopReq(param).then((tData) => {
                    let data = tData._param.data[0]
                    data.app_name = param.app_name
                    data.give_pay_rate = this.calcRate(data.give_sum + data.send_total_percent_sum, data.pay_sum)
                    data.game_win_lose_rate = this.calcRate(data.game_loss_sum, data.bet_sum)
                    data.pay_put_rate = this.calcRate(data.pay_sum - data.put_sum, data.pay_sum)
                    let param1 = this.copyData(param)
                    param1.param._param.stime -= 24 * 60 * 60
                    param1.param._param.etime -= 24 * 60 * 60
                    TransTopReq(param1).then((yData) => {
                        let all = alls[param.platid]
                        if (!this.panelName.includes(`${param.platid}`)) {
                            this.panelName.push(`${param.platid}`)
                        }
                        let data1 = yData._param.data[0]
                        data.pay_ave_offset = data.pay_ave - data1.pay_ave
                        data.pay_sum_offset = data.pay_sum - data1.pay_sum
                        data.bet_pay_rate_offset = data.bet_pay_rate - data1.bet_pay_rate
                        data1.pay_put_rate = this.calcRate(data1.pay_sum - data1.put_sum, data1.pay_sum)

                        all.put_sum += data.put_sum // 当日转出金额
                        all.pay_sum += data.pay_sum
                        all.y_pay_sum += data1.pay_sum //昨日转入金额汇总
                        all.y_pay_num += data1.pay_user_num
                        all.pay_num += data.pay_user_num //当日转入金额汇总

                        all.y_put_sum += data1.put_sum //昨日转出金额
                        all.bet_sum += data.bet_sum //当日转入金额汇总
                        all.y_bet_sum += data1.bet_sum //昨日投注金额汇总
                        all.pay_ave = this.calcRate(all.pay_sum, all.pay_num)
                        all.pay_ave_offset = all.pay_ave - this.calcRate(all.y_pay_sum, all.y_pay_num)

                        all.pay_sum_offset += data.pay_sum_offset
                        all.game_loss_sum += data.game_loss_sum
                        all.percent_sum += data.percent_sum
                        all.send_total_percent_sum += data.send_total_percent_sum
                        all.give_sum += data.give_sum
                        all.new_win_sum += data.new_win_sum //汇总当日营收金额
                        all.y_new_win_sum += data1.new_win_sum //汇总昨日营收金额
                        all.pay_winner += data.pay_winner //汇总当日转入赢家
                        all.pay_loser += data.pay_loser //汇总当日转入输家
                        all.y_pay_winner += data1.pay_winner //汇总昨日转入赢家
                        all.y_pay_loser += data1.pay_loser //汇总昨日转入输家
                        all.bet_pay_rate = this.calcRate(all.bet_sum, all.pay_sum) //汇总当日投注转入比
                        all.y_bet_pay_rate = this.calcRate(all.y_bet_sum, all.y_pay_sum) //汇总昨日投注转入比
                        all.bet_pay_rate_offset = all.bet_pay_rate - all.y_bet_pay_rate //汇总投注转入环比
                        all.pay_put_rate = this.calcRate(all.pay_sum - all.put_sum, all.pay_sum) //汇总当日转入转出比
                        all.y_pay_put_rate = this.calcRate(all.y_pay_sum - all.y_put_sum, all.y_pay_sum) //汇总昨日日转入转出比
                        all.pay_winner_rate = this.calcRate(all.pay_winner, all.pay_winner + all.pay_loser) //汇总当日转入赢家占比
                        all.y_pay_winner_rate = this.calcRate(all.y_pay_winner, all.y_pay_winner + all.y_pay_loser) //汇总昨日转入赢家占比
                        all.new_win_rate = this.calcRate(all.new_win_sum, all.pay_sum) //汇总当日营收比
                        all.give_pay_rate = this.calcRate(all.give_sum + all.send_total_percent_sum, all.pay_sum) //汇总当日佣金转入比
                        all.game_win_lose_rate = this.calcRate(all.game_loss_sum, all.bet_sum) //汇总当日游戏盈利率
                        data.platid = param.platid
                        this.setCellClassName(all)
                        this.setCellClassName(data)
                        let tableFind = this.table.data.find((el) => el.data[0].platid == param.platid)
                        if (tableFind) {
                            tableFind.data.pop()
                            tableFind.data.push(...[data, all])
                        } else {
                            this.table.data.push({
                                platname: param.platname,
                                platid: param.platid,
                                data: [data, all]
                            })
                        }
                        loadingArr.shift()
                        if (loadingArr.length == 0) this.closeTimer()
                        this.toHttp(httpList, alls, loadingArr)
                    })
                })
            }
        },
        setCellClassName(from) {
            if (from.give_pay_rate > 0.1) {
                from.cellClassName = {
                    give_pay_rate: 'is-red'
                }
            } else {
                delete from.cellClassName
            }
        },
        //透传接口请求参数 请求方法 请求参数
        getTransTopParams(func, param) {
            return {
                mod: 'root',
                platid: param.platid,
                app_id: param.app_id,
                app_name: param.app_name,
                platname: param.platname,
                param: {
                    _mod: 'manager',
                    _func: func,
                    _param: {
                        ...param
                    }
                }
            }
        },
        //关闭定时器
        closeTimer() {
            this.loading = false
            clearTimeout(this.TransTopReqTimer)
            this.TransTopReqTimer = null
        },
        //批量请求开启定时器8秒超时
        openTimer() {
            this.closeTimer()
            this.loading = true
            this.TransTopReqTimer = setTimeout(() => {
                this.loading = false
            }, 8000)
        },
        getCompColor(val) {
            // : val > 0 ? "#32CD32"
            return val < 0 ? 'red' : 'black'
        },
        getTrendIcon(h, value) {
            if (value >= 0) return
            return h('Icon', {
                props: {
                    type: value < 0 ? 'md-arrow-down' : 'md-arrow-up',
                    color: value < 0 ? 'red' : '#32CD32',
                    size: 16
                },
                style: {
                    marginLeft: '4px'
                }
            })
        }
    }
}
</script>

<style scoped lang="less">
/deep/ .ivu-table .is-red {
    background-color: rgb(250, 50, 50);
    // color: #fff;
}
</style>
